import * as React from 'react'
import { useEffect } from 'react'
import { INotification } from '../../common/notifications/NotificationReducers'
import { useAnnouncer } from '../a11y/useAnnouncer'
import Notification from './Notification'

export interface INotificationsProps {
  notification: INotification | null
}

export default function Notifications({ notification }: INotificationsProps) {
  const announce = useAnnouncer()

  useEffect(() => {
    if (!notification) return
    const text = typeof notification.content === 'string' ? notification.content : ''
    if (text) announce(text, notification.type === 'warning' ? 'assertive' : 'polite')
  }, [notification, announce])

  return notification ? <Notification {...notification}>{notification.content}</Notification> : null
}
